function filterShades(context) {
  const skinToneFilter = context.querySelector('input[name="skin-tone"]');
  const underToneFilter = context.querySelector('input[name="undertone"]');
  if (!skinToneFilter || !underToneFilter) return;
  const selectedShade = context.querySelector('input[name="skin-tone"]:checked')?.value;
  const selectedUndertone = context.querySelector('input[name="undertone"]:checked')?.value;
  const allLabel =
    context.querySelector(".tone-picker__wrapper")?.dataset?.allLabel || window.HB_THEME_LABELS?.all || "";

  const isAllValue = (value) => {
    if (typeof HB_isAllLabel === "function") return HB_isAllLabel(value);
    const normalized = (value || "").toLowerCase().trim();
    return (
      normalized === (allLabel || "").toLowerCase().trim() ||
      ["all", "tout", "tutto", "todo", "alle"].includes(normalized)
    );
  };

  function filterAttributes() {
    const existedSt = [];
    const existedUt = [];

    context.querySelectorAll(".attr-main-wrapper").forEach((element) => {
      const dataSt = element.dataset.st;
      const dataUt = element.dataset.ut;
      if (!dataSt && !dataUt) return;
      const showByShade = dataSt === selectedShade || isAllValue(selectedShade);
      const showByUndertone = dataUt === selectedUndertone || isAllValue(selectedUndertone);
      element.classList.toggle("hide-shade", !(showByShade && showByUndertone));
    });

    function toggleExistedAttributes(selector, existedAttributes) {
      context.querySelectorAll(selector).forEach((element) => {
        const off = !existedAttributes.includes(element.value) && !isAllValue(element.value);
        element.classList.toggle("disabled", off);
        // Announce what the grey styling shows; native disabled would change the arrow-key order.
        if (off) element.setAttribute("aria-disabled", "true");
        else element.removeAttribute("aria-disabled");
      });
    }

    // 1. Find all undertones related to the selected skin tone
    context
      .querySelectorAll(
        `.attr-main-wrapper${
          isAllValue(selectedShade) ? "[data-st]" : '[data-st*="' + selectedShade + '"]'
        }`,
      )
      .forEach((element) => {
        const dataUt = element.dataset.ut;
        if (!existedUt.includes(dataUt)) {
          existedUt.push(dataUt);
        }
      });
    toggleExistedAttributes(".undertone-options .shade-option", existedUt);

    // 2. Find all skin tones related to the selected undertone
    context
      .querySelectorAll(
        `.attr-main-wrapper${
          isAllValue(selectedUndertone) ? "[data-ut]" : '[data-ut*="' + selectedUndertone + '"]'
        }`,
      )
      .forEach((element) => {
        const dataSt = element.dataset.st;
        if (!existedSt.includes(dataSt)) {
          existedSt.push(dataSt);
        }
      });
    toggleExistedAttributes(".skin-tone-options .shade-option", existedSt);
  }

  // Initial filter based on the default selected options
  filterAttributes();
}

var setupTonePicker = function (context = document) {
  function updateSelection(event) {
    const name = event.target.name;
    context.querySelectorAll(`input[name="${name}"]`).forEach((radio) => (radio.checked = false));
    event.target.checked = true;
    filterShades(context);
  }
  context.querySelectorAll('input[name="skin-tone"], input[name="undertone"]').forEach((radio) => {
    radio.addEventListener("click", updateSelection);
  });
};

document.addEventListener("DOMContentLoaded", function () {
  setupTonePicker(); // PDP
  document.querySelectorAll("quick-add-modal").forEach((modal) => {
    // QUICK VIEW
    modal.addEventListener("product-info:loaded", ({ target }) => {
      setupTonePicker(target);
    });
  });
});
